<template>
  <div class="row myrow">
    <div class="col-xs-6 mycol">
      <table class="co-executor">
        <thead>
          <tr>
            <td>№ п/п</td>
            <td>
              Продукт
            </td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in project.PROJECT_PRODUCTS.items"
            :key="index"
          >
            <template v-if="editable">
              <td>{{ index + 1 }}</td>
              <td
                v-if="programmCode !== 'lekarstva'"
                v-bind:class="{
                  'has-error': hasError(index, 'UF_PRODUCT_TEXT')
                }"
              >
                <textarea
                  class="i-main-style t-co-executor-style t-dop-style"
                  v-model="item.UF_PRODUCT_TEXT"
                  maxlength="200"
                  style="width: 96%"
                  @keyup="removeError(index, 'UF_PRODUCT_TEXT')"
                />
                <span class="frp-input-description"
                  >Доступно для ввода символов:
                  {{ countEntChar(item.UF_PRODUCT_TEXT, 200) }}
                </span>
                <div class="error-text">
                  {{ errorText(index, "UF_PRODUCT_TEXT") }}
                </div>
              </td>
              <td v-else>
                <select
                  class="form-control sel-dropdown i-main-style i-wid-50"
                  v-model="item.UF_PRODUCT_ID"
                >
                  <option
                    v-for="product in directory.sp_project_products_list"
                    :key="product.ID"
                    :value="product.ID"
                    v-if="isAllowed(product)"
                  >
                    {{ product.NAME }}
                  </option>
                </select>
              </td>
              <td>
                <i
                  class="i-delete centerIcon"
                  title="Удалить запись"
                  @click="deleteItem(index)"
                ></i>
              </td>
            </template>

            <template v-else>
              <td>{{ index + 1 }}</td>
              <td v-if="programmCode !== 'lekarstva'">
                {{ item.UF_PRODUCT_TEXT }}
              </td>
              <td v-else>
                <template
                  v-for="product in directory.sp_project_products_list"
                  v-if="product.ID == item.UF_PRODUCT_ID"
                >
                  {{ product.NAME }}
                </template>
              </td>
              <td v-if="editable">
                <i
                  class="i-delete centerIcon"
                  title="Удалить запись"
                  @click="deleteItem(index)"
                ></i>
              </td>
              <td v-else></td>
            </template>
          </tr>
        </tbody>
      </table>
      <div class="add-row" v-show="editable">
        <a class="link-add-row" v-on:click="addItem">Добавить запись</a>
      </div>

      <button
        type="button"
        @click="saveProductsProject()"
        v-show="editable"
        class="btn btn-success"
      >
        Сохранить
      </button>
      <button
        type="button"
        @click="getListProducts()"
        v-show="editable"
        class="btn btn-default btn-style-big"
      >
        Отмена
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ProjectsService } from "@/common/api.service";
import { FETCH_DIRECTORY } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "technological_line",
  props: ["project", "editable", "programmCode"],
  components: {},
  data() {
    return {
      listErrors: []
    };
  },
  async created() {
    await this.$store
      .dispatch(FETCH_DIRECTORY, ["sp_project_products_list"])
      .then(async () => {}, this);
  },
  computed: {
    ...mapGetters(["directory"])
  },
  methods: {
    hasError(col, field) {
      if (typeof this.listErrors[col] !== "undefined") {
        if (typeof this.listErrors[col][field] !== "undefined") {
          return true;
        }
      }

      return false;
    },
    errorText(col, field) {
      if (typeof this.listErrors[col] !== "undefined") {
        if (typeof this.listErrors[col][field] !== "undefined") {
          return this.listErrors[col][field];
        }
      }
      return "";
    },
    removeError(col, field) {
      if (typeof this.listErrors[col] !== "undefined") {
        if (typeof this.listErrors[col][field] !== "undefined") {
          Vue.delete(this.listErrors[col], field);
        }
      }
      return false;
    },
    addItem() {
      if (typeof this.project.PROJECT_PRODUCTS.items === "undefined") {
        this.project.PROJECT_PRODUCTS = {
          items: []
        };
      }
      this.project.PROJECT_PRODUCTS.items.push({
        UF_PRODUCT_TEXT: "",
        UF_PRODUCT_ID: 0
      });
    },
    deleteItem(index) {
      this.project.PROJECT_PRODUCTS.items.splice(index, 1);
    },
    saveProductsProject() {
      this.listErrors = [];
      ProjectsService.saveProductsProject(this.$route.params.id, {
        items: this.project.PROJECT_PRODUCTS.items
      }).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });

            if (!this.listErrors[text.DOP_INFO.ROW_NUM]) {
              this.listErrors[text.DOP_INFO.ROW_NUM] = [];
            }
            this.listErrors[text.DOP_INFO.ROW_NUM][text.DOP_INFO.COL[0]] =
              text.TEXT;
          }, this);
          if (data.isSetTansactionBD) {
            this.project.PROJECT_PRODUCTS.items = data.items;
          }
          return;
        } else {
          this.$toasted.show("Данные о продукции проекта сохранены", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
          if (data.isSetTansactionBD) {
            this.project.PROJECT_PRODUCTS.items = data.items;
          }

          if (data.infoArr.length) {
            data.infoArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "orange",
                position: "bottom-right",
                duration: 4000
              });
            }, this);
          }
        }
      }, this);
    },
    getListProducts() {
      ProjectsService.getProductsProject(this.$route.params.id).then(
        ({ data }) => {
          if (data) {
            this.project.PROJECT_PRODUCTS.items = data;
          }
        },
        this
      );
    },
    countEntChar(value, limit) {
      if (value) {
        return value.length > limit ? 0 : limit - value.length;
      }
      return limit;
    },
    isAllowed(item) {
      let version = 1;
      if (
        this.project.UF_SETTING &&
        parseInt(this.project.UF_SETTING.VERSION_PRODUCT_LIST) > 0
      ) {
        version = parseInt(this.project.UF_SETTING.VERSION_PRODUCT_LIST);
      }

      if (item.VERSION == version) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped></style>
